module.exports = __webpack_public_path__ + "static/box_mid-e07be7f2e4bfe8dd2c84482ac17d7cf9.jpg";